import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function Star({ color = colors.gray['DEFAULT'], ...props }: Props) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00035 0.666672C9.24315 0.666672 9.46511 0.803853 9.5737 1.02102L11.9918 5.85726L16.798 6.6583C17.0349 6.69777 17.2298 6.86631 17.3031 7.09497C17.3764 7.32364 17.3157 7.57409 17.1459 7.74388L13.551 11.3388L14.7532 16.5482C14.809 16.79 14.7201 17.0424 14.5251 17.196C14.3301 17.3495 14.0639 17.3767 13.8419 17.2657L9.00035 14.8449L4.15881 17.2657C3.93679 17.3767 3.67063 17.3495 3.47559 17.196C3.28056 17.0424 3.19171 16.79 3.24753 16.5482L4.44969 11.3388L0.854761 7.74388C0.684971 7.57409 0.62431 7.32364 0.697589 7.09497C0.770868 6.86631 0.965798 6.69777 1.20265 6.6583L6.00887 5.85726L8.427 1.02102C8.53558 0.803852 8.75754 0.666672 9.00035 0.666672ZM9.00035 2.74107L7.00959 6.72258C6.91787 6.90601 6.74392 7.03449 6.54162 7.0682L2.6421 7.71812L5.60746 10.6835C5.76375 10.8398 5.8285 11.0655 5.7788 11.2809L4.80278 15.5103L8.71367 13.5549C8.89414 13.4646 9.10655 13.4646 9.28702 13.5549L13.1979 15.5103L12.2219 11.2809C12.1722 11.0655 12.2369 10.8398 12.3932 10.6835L15.3586 7.71812L11.4591 7.0682C11.2568 7.03449 11.0828 6.90601 10.9911 6.72258L9.00035 2.74107Z"
        fill={color}
      />
    </svg>
  );
}
